import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

const ImageGiffer = styled.img`
  padding: auto;
  display: inline-block;
`;

class GifViewer extends React.PureComponent {
  renderContent = () => {
    const { title, gifSrc, imgSrc } = this.props;

    if (isMobile) {
      return <ImageGiffer src={imgSrc} alt={title} title={title} />;
    }
    return <ImageGiffer src={gifSrc} alt={title} title={title} />;
  };

  render() {
    return this.renderContent();
  }
}

GifViewer.defaultProps = {
  title: '',
  gifSrc: '',
  imgSrc: ''
};

GifViewer.propTypes = {
  title: PropTypes.string,
  gifSrc: PropTypes.string,
  imgSrc: PropTypes.string
};

export default connect()(GifViewer);



// WEBPACK FOOTER //
// ./src/components/GifViewer/index.jsx